import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RichTextEditorServiceService {
  constructor() {}

  getBasicOptions() {
    return {
      promotion: false,
      schema: 'html5',
      plugins: 'lists code fullscreen',
      menubar: false,
      toolbar: 'bold italic underline | bullist numlist | outdent indent | code fullscreen',
      statusbar: false,
      height: 200,
      language: 'da',
      language_url: '/assets/js/tinymce-langs/da.js',
      valid_elements: 'p[style],b,strong,em,span[style],ul,li,ol',
      valid_styles: {
        p: 'padding-left',
        span: 'text-decoration',
      },
      content_css: '/assets/tinymce/tinymce-content.css',
      // tinymce 6 removed editor.setMode (#TINY-8162). @tinymce/tinymce-angular 4.2.4 still calls it
      // when [disabled] / setDisabledState fires. Shim it to the v6 replacement so the wrapper works.
      setup: (editor: any) => {
        if (typeof editor.setMode !== 'function') {
          editor.setMode = (mode: string) => editor.mode.set(mode);
        }
      },
    };
  }
}
